<template>
  <b-card 
    :img-src="unit.thumbnail == '/img/no-img.jpg' ? 'https://res.cloudinary.com/transplan/image/upload/v1598353187/no-img_tumjza.jpg' : unit.thumbnail"
    :img-width="120"
    :title="unit.adres"
    :sub-title="unit.wijk_plaats" 
    img-fluid
    img-left
  >
    {{ unit.unitkenmerk }}
  </b-card>
</template>
<script>
export default {
    name: 'Unit',
    components: {},
    props: {
      unit: {
        type: Object,
        default: null
      }
    },
    data() {
        return  {
        }
    },
    computed: {},
    watch: {},
    mounted () {
        
    },
    methods: {},
          
}
</script>